import { BusinessConfirmation } from '@40seas/entities/business-verification';
import { EnumColor } from '@40seas/frontend/common/providers';

export const businessConfirmationColorMapping = {
    [BusinessConfirmation.Pending]: 'default',
    [BusinessConfirmation.Confirmed]: 'success',
    [BusinessConfirmation.Manual]: 'info',
} as { [key in BusinessConfirmation]: EnumColor };
